<template>
    <InputFieldTemplate @focusChange="this.setFocus"
                        v-show="!this.baseField.isHidden"
                        :disabled="this.baseField.disabled"
                        :hideData="this.baseField.value == null"
                        :is_required="this.baseField.required"
                        :title="this.baseField.view"
                        :error="this.baseField.errorText">
      <input type="number" class="number_input" ref="ruler_input" @input="this.updateInput" @keydown="this.updateInput"/>
    </InputFieldTemplate>
</template>

<script>
import InputFieldTemplate from './InputFieldTemplate.vue';

export default {
  components: {
    InputFieldTemplate,
  },
  data: () => ({

  }),
  props: [
    'baseField',
    // 'validator',
    // 'changeHandler',
  ],
  computed: {

  },
  mounted() {
    this.baseField.addChangeListener(this.setValue);
    setTimeout(() => {
      this.setValue();
      this.updateInput();
    }, 1);
  },
  unmounted() {
    this.baseField.removeChangeListener(this.setValue);
  },
  methods: {
    updateInput() {
      if (this.$refs.ruler_input == null) return;

      const newVal = this.$refs.ruler_input.value;

      const curError = this.baseField.validateValue(newVal);

      if (curError != null) {
        // eslint-disable-next-line vue/no-mutating-props
        this.baseField.value = null;
        // eslint-disable-next-line vue/no-mutating-props
        this.baseField.errorText = curError;
        return;
      }

      this.baseField.setValue(newVal);

      // this.setValue();
    },
    setValue() {
      if (this.$refs.ruler_input == null) return;
      this.$refs.ruler_input.value = isNaN(this.baseField.value) ? '' : this.baseField.value;
    },
    setFocus(val) {
      if (!val) return;
      if (this.$refs.ruler_input == null) return;
      this.$refs.ruler_input.focus();
    },
  },
};
</script>
